import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sokusai-management-forgot-password',
  templateUrl: './sokusai-management-forgot-password.component.html',
  styleUrls: ['../style/global.css', './sokusai-management-forgot-password.component.css'],
})
export class SokusaiManagementForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/wellnesscloud-management/images/logo.svg'
    );
  }
}
